<template>
  <div v-if="!loading"
       class="box">
    <div ref="sortMenu"
         v-if="post_type === 'video'"
         style="width:100vw;"
         class="vid-wrappper">
      <img v-if="isShowIcon"
           @click.stop="cutSizeScreen"
           src="../../../assets/images/dynamic/playBtn.png"
           class="play-img" />
      <!-- <video
            v-if="!isShowIcon && this.$route.path.search('/dynamicTetail') === -1 || this.$route.path.search('/dynamicTetail') !== -1"
            ref="video"
            muted
            @click.stop="cutSizeScreen"
            class="video"
            loop="loop"
            width="100vw"
            x5-playsinline='true'
            playsinline='true'
            webkit-playsinline='true'
            x-webkit-airplay='true'
            x5-video-player-type=h5
            x5-video-player-fullscreen=''
            x5-video-orientation='portraint'
            :poster="images[0].url + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_640,h_360'"
            >
            <source :src="images[0].url" type="video/mp4">
          </video> -->
      <img class="video_img"
           @click.stop="cutSizeScreen"
           width="100%"
           :src="images[0].url + '?x-oss-process=video/snapshot,t_1000,m_fast'" />
    </div>
    <div v-else
         class="images">
      <van-image v-for="item of images"
                 :key="item.id"
                 class="img"
                 width="100%"
                 height="100%"
                 :src="item.url" />
    </div>
    <div class="user">
      <van-image round
                 width="40"
                 height="40"
                 :src="`${user.real_avatar !== 'null' && user.real_avatar !== '' ? user.real_avatar : user.avatar}`" />
      <div class="name">
        <div>{{ user.fullname ? user.fullname : user.nickName }}</div>
        <div class="time">{{createTime.split(' ')[0]}}</div>
      </div>
    </div>
    <div class="label">
      <div class="label_name_box"
           v-for="item of tags"
           :key="item.id"
           @click="goTagDynamics(item)">
        <div class="label_name"># {{item.title}}</div>
      </div>
    </div>
    <div class="content"
         v-html="content">
    </div>
    <div class="dynamicData">
      <div class="dynamicData_box">
        <img class="gongkai"
             src="../../../assets/images/dynamic/gongkai.png">
        <div>{{viewCount}}</div>
      </div>
      <div class="dynamicData_box"
           @click="thumbsUp">
        <img class="dianzhan"
             :src="isUp ? url:url1" />
        <div>{{upCount}}</div>
      </div>
      <div class="dynamicData_box">
        <img class="pinglun"
             src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/message-grey.svg" />
        <div>{{messages.length}}</div>
      </div>
      <div class="dynamicData_box"
           @click="share">
        <img class="fengxiang"
             src="../../../assets/images/dynamic/fengXiang.png">
        <div>分享</div>
      </div>
    </div>
    <div class="message"
         ref="message">
      <h3 class="message_comtent">{{messages.length === 0 ? '暂无留言':`${messages.length}条留言`}}</h3>
      <DynamicMessage v-for="item of messages"
                      @deleteMessage="deleteMessage"
                      @thumbsUp="childthumbsUp(item)"
                      :key="item.id"
                      v-bind="item" />
    </div>
    <div class="new_comment"
         v-show="new_comment_is_show">
      <div class="comment">
        <input class="comment_input"
               v-model="search"
               type="text"
               placeholder="  说点什么">
        <van-button @click="submitCircle"
                    class="comment_btn"
                    round
                    type="info">发表</van-button>
      </div>
    </div>
    <div style="height:40px">

    </div>
  </div>
  <Loading v-else
           :loading="loading" />
</template>

<script>
import DynamicMessage from '../../../components/DynamicMessage'
import { get, post } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { shareDD2, isPc } from '../../../utils/utils'
import Loading from '../../../components/Loading'
import { Toast } from 'vant'
import { messageInform } from '../../../api/api'
export default {
  components: {
    DynamicMessage,
    Loading
  },
  data () {
    return {
      search: '',
      title: '',
      id: '',
      messages: [],
      url: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg',
      url1: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg',
      images: [],
      commentCount: '',
      content: '',
      createTime: '',
      user: {
        id: '',
        nickName: '',
        avatar: ''
      },
      tags: [],
      upCount: '',
      viewCount: '',
      isUp: false,
      loading: true,
      new_comment_is_show: false,
      clientHeight: '',
      post_type: '',
      isShowIcon: true
    }
  },
  mounted () {
    const _this = this
    window.addEventListener('scroll', _this.handleScroll, true)
    _this.id = _this.$route.params.id
    _this.title = _this.$route.query.title
    // console.log('宽度', document.documentElement.clientWidth)
    _this.clientHeight = document.documentElement.clientHeight
    if (dd.env.platform !== 'notInDingTalk') {
      dd.biz.navigation.setRight({
        show: false // 控制按钮显示， true 显示， false 隐藏， 默认true
      })
    }
    Promise.all([_this.getDynamicDetails(), _this.getDynamicMessage()]).then((result) => {
      setTimeout(() => {
        _this.loading = false
      }, 500)
    }).catch((error) => {
      /* eslint-disable */
      console.log(error)
    })
    // dd.device.base.getPhoneInfo({
    //   onSuccess: function (data) {
    //     _this.isPc = false
    //     // alert('现在是手机移动端')
    //   },
    //   onFail: function (err) {
    //     alert(JSON.stringify(err))
    //   }
    // })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    cutSizeScreen () {
      // this.$refs.sortMenu.pause()
      // this.$refs.sortMenu.requestFullscreen()
      // this.$refs.sortMenu.volume = 1
      // this.$refs.sortMenu.play()
      // this.show = true
      // this.$refs.sortMenu1.play()
      this.$bus.$emit('openBigScreen', this.images[0].url)
    },
    // 跳转标签话题
    goTagDynamics (tag) {
      this.$router.push({
        name: 'FilterFind',
        params: {
          id: tag.id,
          title: tag.name || tag.title
        }
      })
    },
    childthumbsUp (item) {
      item.isUp = !item.isUp
      let count = item.upCount
      if (item.isUp) {
        ++count
      } else {
        --count
      }
      item.upCount = count
    },
    submitCircle () {
      const _this = this
      const user = getUser('user')
      const data = {
        userId: user.id,
        circleId: _this.id,
        content: _this.search,
        is_actual: true
      }
      const promise = post({
        url: '/circle/comment',
        data,
        timeout: 25000
      })
      promise.then(res => {
        const { data } = res
        const { content, crateTime, nid: id } = data.detail
        const obj = {
          avatar: user.avatar,
          circleId: _this.id,
          circle_id: _this.id,
          nickName: user.nickName,
          fullname: user.fullname,
          real_avatar: '',
          parentCommentId: null,
          parentNickName: null,
          upCount: 0,
          user__id: user.id,
          is_actual: true,
          isUp: false,
          content,
          crateTime,
          id
        }
        _this.messages.unshift(obj)
        _this.search = ''
        Toast.success('发表成功')
        messageInform({
          circle_id: _this.id,
          action_type: 1,
          mobile: _this.user.username,
          operator_mobile: user.username,
          is_anonymous: false,
          comment_id: null
        })
      }).catch(err => {
        Toast.fail('网络繁忙', JSON.stringify(err))
      })
    },
    handleScroll () {
      if (this.$refs.message.getBoundingClientRect().top < this.clientHeight) {
        this.new_comment_is_show = true
      } else {
        this.new_comment_is_show = false
      }
    },
    async share () {
      if (await isPc()) {
        const txa = document.createElement('textarea')
        txa.value = `dingtalk://dingtalkclient/action/openapp?corpid=ding7a05491d2e914134&container_type=work_platform&app_id=0_941215726&redirect_type=jump&redirect_url=https://ui-circle.fosun.com${window.document.location.pathname}`
        document.body.appendChild(txa)
        txa.select()
        document.execCommand('Copy')
        document.body.removeChild(txa)
        Toast.success('链接已复制到剪贴板')
        return
      }
      console.log(window.document.location.pathname)
      shareDD2({
        type: 0,
        title: `${this.title ? this.title : ' '}`,
        content: this.content,
        url: `dingtalk://dingtalkclient/action/openapp?corpid=ding7a05491d2e914134&container_type=work_platform&app_id=0_941215726&redirect_type=jump&redirect_url=https://ui-circle.fosun.com${window.document.location.pathname}`,
        img: `${this.user.real_avatar !== 'null' && this.user.real_avatar !== '' ? this.user.real_avatar : this.user.avatar}`
      })
    },
    UPimages () {
      const newimages = this.images.filter(item => item.url !== '')
      this.images = newimages
    },
    goCreate () {
      const { id } = this
      this.$router.push(`/exerland/create?circleId=${id}`)
    },
    getDynamicDetails () {
      const user = getUser('user')
      const { id } = this
      const promise = get({
        url: `/circle/detail/${id}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.upUvdata(id)
          Object.assign(this, detail)
          this.UPimages()
        }
      })
    },
    upUvdata (id) {
      const user = getUser('user')
      this.$API.upUvData({
        user: user.id,
        path: `/exerland/pushDynamicDetail/${id}`,
        location: `话题详情-${id}`,
        tracking_type: 5
      })
    },
    deleteMessage () {
      const { id } = this.$route.params
      this.getDynamicMessage(id)
    },
    getDynamicMessage () {
      const user = getUser('user')
      const promise = get({
        url: `/circle/commentTree/${this.id}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.messages = detail
        }
      })
    },
    thumbsUp () {
      const _this = this
      if (this.isUp) {
        this.upCount = this.upCount - 1
      } else {
        this.upCount = this.upCount + 1
      }
      this.isUp = !this.isUp
      const promsie = post({
        url: `/circle/isUp/${this.id}/${getUser('user').id}`,
        data: {
          isUp: this.isUp
        }
      })
      promsie.then(res => {
        const { status } = res
        const user = getUser('user')
        if (this.isUp) {
          messageInform({
            circle_id: _this.id,
            action_type: 2,
            mobile: _this.user.username,
            operator_mobile: user.username,
            is_anonymous: false,
            comment_id: null
          })
        }
        if (!status === 200) {
          this.isUp = !false
          this.upCount = this.upCount - 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  font-size: 0;
  .vid-wrappper {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    .play-img {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -16px;
      margin-top: -16px;
      width: 32px;
      height: 32px;
    }
  }
  .new_comment {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    border-top: 1px solid rgb(239, 236, 236);
    .content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      height: 28px;
    }
    .comment_btn {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 10px;
      height: 28px;
    }
    .comment_input {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      left: 20px;
      font-size: 16px;
      width: 70%;
      height: 28px;
      border: none;
      border-radius: 8px;
      background-color: #f1f0f0;
      color: #000;
    }
  }
  .message {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-top: 29.5px;
    border-top: 1px solid rgb(239, 236, 236);
    .message_comtent {
      padding-left: 15px;
    }
  }
  .dynamicData {
    display: flex;
    font-size: 0px;
    height: 27px;
    line-height: 27px;
    margin-left: 15px;
    .dynamicData_box {
      display: flex;
      margin-right: 16px;
      color: #7f7f7f;
      font-size: 14px;
      img {
        margin: auto;
      }
      .gongkai {
        width: 15.5px;
        height: 10.5px;
      }
      .dianzhan {
        width: 14.2px;
        height: 12.51px;
      }
      .pinglun {
        width: 18px;
        height: 16px;
      }
      .fengxiang {
        width: 12.5px;
        height: 12.5px;
      }
      div {
        margin-left: 3px;
      }
    }
  }
  .content {
    margin: 0 15px 28px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .label {
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - 20px);
    margin: 10.5px 0 24.5px 15px;
    .label_name_box {
      height: 25px;
      line-height: 25px;
      margin-top: 10px;
      // background: #999999;
      // opacity: 0.1;
      background-color: rgba($color: #999999, $alpha: 0.1);
      border-radius: 5px;
      .label_name {
        font-size: 13px;
        font-weight: 500;
        color: #566a93;
        padding: 0 7px;
      }
    }
    .label_name_box:not(:first-child) {
      margin-left: 10px;
    }
  }
  .images {
    margin-bottom: 22.5px;
    .img {
      margin-bottom: 15px;
    }
    .img:last-child {
      margin-bottom: 0;
    }
  }
  .user {
    display: flex;
    font-size: 16px;
    margin-left: 15px;
    .name {
      margin-left: 14.5px;
      .time {
        font-size: 12px;
        color: #999;
      }
    }
  }
}
</style>
